export default function attachBw26Specular(node: HTMLElement): () => void {
  const onMove = (event: PointerEvent) => {
    const rect = node.getBoundingClientRect();
    const x = ((event.clientX - rect.left) / rect.width) * 100;
    const y = ((event.clientY - rect.top) / rect.height) * 100;

    node.style.setProperty('--bw26-mx', `${x}%`);
    node.style.setProperty('--bw26-my', `${y}%`);
  };

  node.addEventListener('pointermove', onMove);

  return () => {
    node.removeEventListener('pointermove', onMove);
  };
}
